// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"d9b0f8fa","454":"a730a31c","753":"89117c35"}[chunkId] + ".js";
};